import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/styles/index.css");
